export const EEnableStatusType = {
  Active: 0,

  Inactive: 1,

  All: 2,
} as const

export type EEnableStatusType = (typeof EEnableStatusType)[keyof typeof EEnableStatusType]
